import { AspectRatioContainer } from '@mentimeter/editor-canvas';
import { ViewOnly } from '@mentimeter/sfinx';
import { EditorCanvasAreaSlideLayout } from 'features/core/edit_view/application/EditorCanvasAreaSlideLayout';
import { ConfigProvider } from 'features/core/presentation/shared/config';
import type { SeriesWithSlideDeck } from '@mentimeter/view-only-schema/api-types-overrides';
import { PresentationContainer } from '../../PresentationContainer';

export const ViewOnlyCanvas = ({
  questionId,
  series,
  shouldAnimate,
}: {
  questionId: string;
  series: SeriesWithSlideDeck;
  shouldAnimate: boolean;
}) => (
  <AspectRatioContainer>
    <ConfigProvider enableAnimations={shouldAnimate} enableHotkeys={false}>
      <PresentationContainer
        series={series}
        questionId={questionId}
        mode="view"
      >
        <EditorCanvasAreaSlideLayout
          isCanvasInteractive={false}
          isSlideActiveAndSidebarClosed
        >
          <ViewOnly />
        </EditorCanvasAreaSlideLayout>
      </PresentationContainer>
    </ConfigProvider>
  </AspectRatioContainer>
);
